export const designServicesContent = {
  title: 'Let us design it for you',
  subtitle: 'Design Services',
  price: '$10',
  bulletPoints: [
    'Quick, 24-hour turnaround (excluding weekends and holidays)',
    'Up to 3 revisions to perfect your design',
    'A professional, ready-to-print design',
  ],
  flyoutDescription: 'Get a custom design by professional designers, fast',
  imageUrl:
    'https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto:best,dpr_auto/v1755694304/Image-for-panel_mzd4qu.png',
  ctaText: 'Explore professional design options',
  buildNextStepUrl: (mpvId: string, locale: string): string =>
    `/design/get-started?mpvID=${mpvId}&locale=${locale}`,
  tileImage: 'https://cms.cloudinary.vpsvc.com/image/upload/v1760958745/avatar_stack_3_ky0a26.png',
};
